import React from 'react';

import RequestQueueTablePage from './RequestQueueTablePage';
import { waitingShipmentsFallbackQueue } from './requestQueueFallbacks';


export default function WaitingShipmentsPage() {
    return (
        <RequestQueueTablePage
            title="Ожидание отправок"
            queueName="waiting_shipments"
            summaryLabel="Заявок к отправке"
            emptyQueueText="Сейчас нет заявок в ожидании отправки."
            warningText="Не удалось загрузить очередь отправок. Показан локальный пример."
            fallbackQueue={waitingShipmentsFallbackQueue}
            detailPathPrefix="/app/shipments/waiting"
        />
    );
}
